import React, { useState } from "react";
import {
  Dimensions,
  FlatList,
  Image,
  Modal,
  Pressable,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";

import AppFonts from "../../../Constants/AppFonts";
import AppColors from "../../../Constants/AppColors";
import AppImages from "../../../Constants/AppImages";
import {
  AudioPlay,
  BatteryStatus,
  EmailCom,
  ModalDel,
  PaymentBill,
  VacationData,
} from "../../../Constants/Data";
// import { Dropdown } from "react-native-element-dropdown";
import Appstyles from "../../../Constants/AppStyles";

const { width, height } = Dimensions.get("window");

const Vacation = ({ navigation }) => {
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };
  const [DotModal, setDotModal] = useState(false);
  const [Modalvisible1, setModalvisible1] = useState(false);
  const [selectedButton, setSelectedButton] = useState(1);

  const handleBoxPressbtn = (item) => {
    setSelectedButton(item);
  };
  // render
  //--------------Overview-------------
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(0);

  const handleButtonPress = (index) => {
    setSelectedButtonIndex(index);
  };

  const VacationData = [
    {
      id: 1,

      Name: "Vacation",
      Trip: "Wedding",
      carname: "Sisters Wedding",
      Driver: "01-01-2023",
      Subject: "01-01-2023 ",
      Status: "Inactive",
    },
    {
      id: 2,
      Name: "Vacation",
      Trip: "Wedding",
      carname: "Sisters Wedding",
      Driver: "01-01-2023",
      Subject: "01-01-2023 ",
      Status: "Inactive",
    },
    {
      id: 3,
      Name: "Vacation",
      Trip: "Wedding",
      carname: "Sisters Wedding",
      Driver: "01-01-2023",
      Subject: "01-01-2023 ",
      Status: "Inactive",
    },
    {
      id: 4,
      Name: "Vacation",
      Trip: "Wedding",
      carname: "Sisters Wedding",
      Driver: "01-01-2023",
      Subject: "01-01-2023 ",
      Status: "Inactive",
    },
    {
      id: 5,
      Name: "Vacation",
      Trip: "Wedding",
      carname: "Sisters Wedding",
      Driver: "01-01-2023",
      Subject: "01-01-2023 ",
      Status: "Inactive",
    },
    {
      id: 6,
      Name: "Vacationghtyh",
      Trip: "Wedding",
      carname: "Sisters Wedding",
      Driver: "01-01-2023",
      Subject: "01-01-2023 ",
      Status: "Inactive",
    },
  ];

  //---------Search Text Input---------//
  const [selectedItem, setSelectedItem] = useState(null);
  const [data, setData] = useState(VacationData);
  const [searchText, setSearchText] = useState(""); // State for search input

  const handleSearch = (text) => {
    setSearchText(text);
    // Implement search logic here to filter the data based on the entered text
    const filteredData = VacationData.filter((item) =>
      item.NewYear.toLowerCase().includes(text.toLowerCase())
    );
    setData(filteredData);
  };
  //-------Del FlatList ---------//
  const handleThreeDotPress = (item) => {
    setSelectedItem(item);
    setDotModal(true);
  };
  const handleDeleteConfirmation = () => {
    setDotModal(false);
    setModalvisible1(true);
  };
  const handleDelete = () => {
    const updatedData = data.filter((item) => item.id !== selectedItem.id);
    setData(updatedData);
    setModalvisible1(false);
    setSelectedItem(null);
  };
  const handlePress = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      window.history.back();
    } else {
      // Fallback to home or custom action
      window.location.href = "/";
    }
  };

  return (
    <SafeAreaView style={Appstyles.safe}>
      <View style={Appstyles.HeaderMain}>
        <View style={Appstyles.HeaderSec}>
          <TouchableOpacity style={Appstyles.Arrowstyle} onPress={handlePress}>
            <Image
              source={AppImages.Backbtn}
              style={Appstyles.ArrowImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <Text style={Appstyles.HeaderText}>Vacation</Text>
        </View>
        <View style={Appstyles.rc}>
          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={Appstyles.BellImage}
              resizeMode="contain"
            />
          </TouchableOpacity>

          <TouchableOpacity onPress={() => navigation.navigate("AddVacation")}>
            <Image
              source={AppImages.Plus}
              style={Appstyles.PlusImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>
      <View style={{}}>
        <View style={{ backgroundColor: AppColors.white, marginTop: 20 }}>
          <View
            style={{
              backgroundColor: AppColors.white,
            }}
          >
            <View style={styles.SecMain}>
              <View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 20,
                    marginTop: 20,
                  }}
                >
                  <View style={Appstyles.Searchvii6}>
                    <TextInput
                      style={Appstyles.TextInputr7}
                      placeholder={t("common:translation.Search...")}
                      placeholderTextColor="#ACACACCC"
                      editable={true}
                      // value={searchText}

                      autoCapitalize="none"
                      value={searchText} // Bind search input value to state
                      onChangeText={handleSearch}
                    />

                    <View
                      style={{
                        alignItems: "flex-end",

                        justifyContent: "center",

                        flex: 1,
                      }}
                    >
                      <Image
                        source={AppImages.search}
                        style={{ width: 20, height: 20, marginRight: 20 }}
                      />
                    </View>
                  </View>
                </View>
              </View>
            </View>
            <ScrollView
              contentContainerStyle={{ flexGrow: 1 }}
              showsVerticalScrollIndicator={false}
            >
              <FlatList
                showsVerticalScrollIndicator={false}
                ListFooterComponent={() => <View style={{ padding: 155 }} />}
                data={data}
                nestedScrollEnabled
                renderItem={({ item }) => (
                  <View style={{ marginHorizontal: 20 }}>
                    <View style={styles.Flatmain}>
                      <View style={styles.FlatmainSec}>
                        <View style={styles.FlatImg}>
                          <Text style={styles.FlatTxtSec}>{item.Name}</Text>
                          <TouchableOpacity
                            onPress={() => handleThreeDotPress(item)}
                          >
                            <Image
                              source={AppImages.Threedots}
                              style={{
                                width: 15,
                                height: 15,
                                alignItems: "center",
                                marginRight: 10,
                              }}
                              resizeMode="contain"
                            />
                          </TouchableOpacity>
                        </View>
                      </View>
                      <View>
                        <View
                          style={{
                            borderWidth: 0.5,
                            borderColor: AppColors.grey,
                          }}
                        ></View>
                      </View>
                      <View
                        style={{
                          marginHorizontal: 20,
                          marginBottom: 10,
                        }}
                      >
                        <TouchableOpacity
                          style={{}}
                          onPress={() => handleBoxPressbtn(1)}
                        >
                          <View style={{ marginTop: 10, flexDirection: "row" }}>
                            <View style={{ width: "50%" }}>
                              <Text style={styles.Textt}>Vacation Name</Text>
                            </View>
                            <View>
                              <Text style={styles.Textt}>Description</Text>
                            </View>
                          </View>
                          <View style={{ flexDirection: "row" }}>
                            <View style={{ width: "50%" }}>
                              <Text style={styles.Textt1}>{item.Trip}</Text>
                            </View>
                            <View>
                              <Text style={styles.Textt1}>{item.carname}</Text>
                            </View>
                          </View>
                          <View style={{ marginTop: 10, flexDirection: "row" }}>
                            <View style={{ width: "50%" }}>
                              <Text style={styles.Textt}>Start Date</Text>
                            </View>
                            <View>
                              <Text style={styles.Textt}>End Date</Text>
                            </View>
                          </View>
                          <View style={{ flexDirection: "row" }}>
                            <View style={{ width: "50%" }}>
                              <Text style={styles.Textt1}>{item.Driver}</Text>
                            </View>
                            <View>
                              <Text style={styles.Textt1}>{item.Subject}</Text>
                            </View>
                          </View>
                          <View style={{ marginTop: 10, flexDirection: "row" }}>
                            <View style={{ width: "50%" }}>
                              <Text style={styles.Textt}>Status</Text>
                            </View>
                          </View>
                          <View style={{ width: "50%" }}>
                            <Text style={styles.Textt1}>{item.Status}</Text>
                          </View>
                        </TouchableOpacity>
                      </View>
                    </View>
                  </View>
                )}
              />
            </ScrollView>
          </View>
        </View>
      </View>
      <Modal
        animationType="slide"
        visible={DotModal}
        onRequestClose={() => {
          setDotModal(false);
        }}
        transparent={true}
      >
        <TouchableWithoutFeedback onPress={() => setDotModal(false)}>
          <View style={styles.feed}></View>
        </TouchableWithoutFeedback>
        <View style={styles.viww}>
          <TouchableOpacity style={styles.hsh}>
            <Image source={AppImages.LineBar} style={styles.jns} />
          </TouchableOpacity>

          <TouchableOpacity
            style={{
              marginTop: 10,

              flexDirection: "row",
            }}
            onPress={() => [
              setDotModal(false),
              navigation.navigate("EditVacation"),
            ]}
          >
            <View style={styles.yooo}>
              <Text style={styles.modo}>Edit</Text>
            </View>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.fffsf}
            onPress={handleDeleteConfirmation}
          >
            <View style={styles.yooo}>
              <Text style={styles.ttxt}>Delete</Text>
            </View>
          </TouchableOpacity>
        </View>
      </Modal>

      {/* //-----------DeleteModal------// */}

      <Modal
        animationType="slide"
        transparent={true}
        visible={Modalvisible1}
        onRequestClose={() => {
          setModalvisible1(!Modalvisible1);
        }}
      >
        <Pressable
          onPress={() => setModalvisible1(false)}
          style={styles.presse}
        >
          <View style={styles.dsdd}>
            <View style={styles.sss}>
              <View style={styles.fd}>
                <View style={{}}>
                  <Text style={styles.hbh}>Delete Vacation</Text>
                </View>
              </View>
              <TouchableOpacity
                onPress={() => {
                  setModalvisible1(false);
                }}
              >
                <Image
                  source={AppImages.cross}
                  style={styles.hhsj}
                  resizeMode="contain"
                />
              </TouchableOpacity>
            </View>

            <View style={styles.lins}></View>
            <View style={styles.fasfd}>
              <Text style={styles.sdsds}>
                Are you sure you want to delete this Vacation ?
              </Text>
            </View>

            <View style={styles.mmm}>
              <View style={styles.hox}>
                {ModalDel.map((item, index) => (
                  <View
                    onPress={() => handleBoxPressbtn(item)}
                    style={styles.presss}
                  >
                    {selectedButton === index ? (
                      <TouchableOpacity
                        onPress={() => [
                          handleDelete(),
                          // handleBoxPressbtn(item),
                          setModalvisible1(false),
                        ]}
                      >
                        <View style={{}}>
                          <View
                            style={[
                              styles.LoginWithOtpVw,
                              {
                                backgroundColor:
                                  selectedButton === index
                                    ? AppColors.brown
                                    : AppColors.C4900C,
                              },
                            ]}
                          >
                            <Text
                              style={[
                                styles.RegisterTxt,
                                {
                                  color:
                                    selectedButton === index
                                      ? AppColors.white
                                      : AppColors.C4900CC,
                                },
                              ]}
                            >
                              {item.label}
                            </Text>
                          </View>
                        </View>
                      </TouchableOpacity>
                    ) : (
                      <TouchableOpacity
                        onPress={() => [
                          // handleBoxPressbtn(item),
                          setModalvisible1(false),
                        ]}
                      >
                        <View style={{}}>
                          <View style={{}}>
                            <View
                              style={[
                                styles.LoginWithOtpVw,
                                {
                                  backgroundColor:
                                    selectedButton === index
                                      ? AppColors.brown
                                      : AppColors.C4900C,
                                },
                              ]}
                            >
                              <Text
                                style={[
                                  styles.RegisterTxt,
                                  {
                                    color:
                                      selectedButton === index
                                        ? AppColors.white
                                        : AppColors.C4900CC,
                                  },
                                ]}
                              >
                                {item.label}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </TouchableOpacity>
                    )}
                  </View>
                ))}
              </View>
            </View>
          </View>
        </Pressable>
      </Modal>
    </SafeAreaView>
  );
};

export default Vacation;

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: AppColors.sandal },
  img: { width: 16, height: 20 },
  imgg: { width: 18, height: 18, marginLeft: 20 },
  simp: {
    justifyContent: "center",
  },
  Txtxt: {
    alignItems: "center",
    justifyContent: "center",
    fontFamily: AppFonts.OverpassBold,

    fontSize: 18,
    color: AppColors.brown1,
  },
  Viewwd: {
    backgroundColor: AppColors.sandal,
    width: "100%",
    padding: 20,
    borderBottomLeftRadius: 15,
    borderBottomWidth: 1.5,
    borderBottomRightRadius: 15,
    borderBottomColor: AppColors.brown,
  },
  HeaderMain: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: AppColors.white,
    height: 58,
    justifyContent: "space-between",
    paddingHorizontal: 20,
    shadowColor: AppColors.brown,

    shadowOffset: { width: 10, height: 10 },
    shadowOpacity: 10,
    shadowRadius: 10,
    elevation: 20,
  },
  HeaderSec: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  HeaderBackTouch: { height: 30, width: 30, justifyContent: "center" },
  HeaderBackImage: { width: 8, height: 15 },
  HeadTextVechicle: {
    color: "#8F4300",
    fontFamily: AppFonts.OverpassSemiBold,
    fontSize: 16,
  },
  ImagesView: {
    flexDirection: "row",
    alignItems: "center",
  },
  TExtinputView: {
    marginTop: 10,
    borderRadius: 10,
    height: height * 0.07,
    backgroundColor: AppColors.sandal,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,

    borderRadius: 10,
    borderColor: AppColors.sandal,
    height: height * 0.07,
    borderWidth: 1,
  },
  container: {
    flex: 1,
    justifyContent: "center",
    paddingBottom: 20,
  },
  listContainer: {
    marginTop: 20,
    borderRadius: 10,
    alignItems: "center",
    flexDirection: "row",
  },
  TextList: {
    marginLeft: 10,
    color: AppColors.brown,
    fontFamily: AppFonts.OverpassBold,
  },

  //-------cancel  btn---//
  sty: {
    flexDirection: "row",
    marginVertical: 20,
  },
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    height: 45,
    width: "100%",
  },
  RegisterTxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  //-------------
  Touch: { justifyContent: "center", alignItems: "center" },
  Txtst: {
    color: AppColors.brown,
    fontFamily: AppFonts.OverpassBold,
    fontSize: 18,
    fontWeight: "700",
  },

  hox: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  presss: {
    width: "30%",
    marginHorizontal: 20,
  },
  //---------
  fle: {
    flex: 1,
  },

  mar: { marginHorizontal: 20 },

  SecMain: { marginHorizontal: 20 },
  TExtinputView: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",

    width: "100%",
    paddingVertical: 10,
    // height: height * 0.04,
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,
    width: "80%",
    borderRadius: 10,
    borderColor: AppColors.sandal,
    // height: height * 0.05,
    borderWidth: 1,
    paddingLeft: 20,
    flexDirection: "row",

    borderRadius: 8,
    justifyContent: "space-between",

    shadowColor: "#000001A",
    shadowOffset: { width: 1, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 1,
    // elevation: 6,
  },
  ExImport: { flexDirection: "row", marginHorizontal: 10 },
  Flatmain: {
    marginBottom: 20,
    backgroundColor: "#F6EFE9",
    borderRadius: 10,
  },
  FlatmainSec: {
    // margin: 10,
    marginLeft: 10,
    paddingVertical: 10,
    paddingHorizontal: 10,
  },
  FlatImg: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  FlatTxtSec: {
    // marginTop: 5,
    fontSize: 14,

    fontFamily: AppFonts.OverpassSemiBold,
    color: AppColors.brown,
  },
  tabe: { width: 155 },
  FlatTxtT2: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  //   LineBars: {
  //     width: '180%',
  //     right: 20,
  //     // position: 'absolute',
  //     borderTopColor: AppColors.brown,
  //     borderTopWidth: 0.7,
  //     opacity: 0.099,
  //     marginTop: 10,
  //   },
  CopyText: {
    fontSize: 14,
    marginTop: 3,

    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  CopyTextSec: {
    fontSize: 14,
    marginTop: 3,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  CopyTextSe: {
    fontSize: 14,
    marginTop: 3,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },

  Row: { flexDirection: "row" },

  Textt: {
    marginTop: 3,
    fontSize: 12,

    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  Textt1: {
    fontSize: 14,

    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
  },

  TextTwo: {
    fontSize: 12,
    marginTop: 3,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  //--------modal Del
  hox: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  presss: {
    width: "40%",
    marginHorizontal: 10,
  },
  //-------cancel  btn---//
  sty: {
    flexDirection: "row",
    marginVertical: 10,
  },
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    height: 35,
    width: "100%",
  },
  RegisterTxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  lins: {
    borderTopWidth: 1,
    marginHorizontal: 20,
    // right: 20,
    borderTopColor: AppColors.sandal,
    marginTop: 20,
  },
  vee: {
    alignItems: "flex-end",
    justifyContent: "center",
    flex: 1,
  },
  im: { width: 20, height: 20, marginRight: 30 },
  too: { alignSelf: "flex-end", justifyContent: "center" },
  ims: { width: 22, height: 22 },
  ha: { width: 22, height: 22, marginLeft: 10 },
  iamge: { width: 22, height: 22, alignItems: "center" },
  feed: { backgroundColor: AppColors.ModalColor, flex: 1 },
  viww: {
    width: "100%",
    backgroundColor: "white",

    borderTopRightRadius: 16,
    borderTopLeftRadius: 16,
    position: "absolute",
    bottom: 0,
    padding: 20,
  },
  hsh: { justifyContent: "center", alignItems: "center" },
  jns: { width: "15%", height: 2 },
  yooo: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
  },
  ttxt: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.dualbrown,
  },
  ttxt1: {
    fontFamily: AppFonts.OverpassSemiBold,

    fontSize: 16,
    color: AppColors.brown1,
  },
  fffsf: {
    marginTop: 5,
    flexDirection: "row",
  },
  modo: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.brown,
  },
  presse: {
    flex: 1,
    backgroundColor: AppColors.ModalColor,
    alignItems: "center",
    justifyContent: "center",
  },
  dsdd: {
    backgroundColor: "white",
    borderRadius: 20,
    marginHorizontal: 20,
    width: "80%",
    paddingTop: 15,
  },
  sss: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
    alignItems: "center",
  },
  fd: { alignItems: "center" },
  hbh: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 20,
    lineheight: 25.32,
    color: AppColors.brown1,
  },
  hhsj: { width: 12, height: 12, alignItems: "center" },
  fasfd: { marginTop: 20, marginHorizontal: 20 },
  sdsds: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    lineheight: 17.72,
    color: AppColors.brown1,
  },
  mmm: {
    flexDirection: "row",
    alignSelf: "flex-end",

    marginHorizontal: 20,
  },
  toda: { marginTop: 20, flexDirection: "row" },
  Searchstyle: {
    flex: 1,
    backgroundColor: "white",
    width: "100%",
    // marginTop: 20

    // flexGrow: 30,
  },
  tab: { backgroundColor: AppColors.brown },
  container: {
    marginHorizontal: 20,
    backgroundColor: AppColors.white,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: AppColors.white1,
    marginTop: 15,
    paddingHorizontal: 5,
    paddingVertical: 12,

    // paddingVertical: Platform.OS == "android" ? 7 : 10,
    height: 50,
  },

  dropdown: {},

  icon: {
    height: 12,
    width: 15,
    marginRight: 10,
  },
  label: {
    position: "absolute",
    left: 22,
    top: 8,
    zIndex: 999,
    paddingHorizontal: 8,
    fontSize: 14,
  },
  placeholderStyle: {
    fontSize: 14,
    fontFamily: AppFonts.ProximaRegular,
    color: AppColors.dualbrown,
    paddingLeft: 10,
  },
  selectedTextStyle: {
    fontSize: 14,
    fontFamily: AppFonts.ProximaRegular,
    color: AppColors.brown,
    paddingLeft: 5,
    fontFamily: AppFonts.BarlowMedium,
  },
  iconStyle: {},
  inputSearchStyle: {
    height: 40,
    fontSize: 26,
  },
  hjhah: {
    height: height * 0.68,

    marginTop: 20,
  },
  mam: { flex: 1, position: "relative" },
  hjnshj: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    paddingRight: 15,
    position: "absolute",
    bottom: 15,
    left: 0,
    right: 0,
    zIndex: 1,
  },
  same: { width: 40, height: 40, marginLeft: 15 },
  fleee: { flex: 1 },
});
